module.exports = __webpack_public_path__ + "static/media/minsky.5472b384.jpg";